import * as React from 'react';
import { useCallback } from 'react';
import {
	Dropdown,
	DropdownCheckboxItem,
	DropdownContent,
	DropdownItem,
	DropdownSelectTrigger,
	DropdownSeparator,
} from '../../../../../web/components-v2/Dropdown';
import { bs } from '../../../../../web/styles/styles';
import { useQuotaTeamAutocompleteQuery } from '../../../../queries/Aida/useQuotaTeamAutocomplete';

interface IProps {
	onChange?: (values: string[]) => void;
	selectedQuotaTeams?: string[];
}

export const QuotaTeamMultiSelect: React.FC<IProps> = ({ onChange, selectedQuotaTeams = [] }) => {
	const { data: quotaTeams = [], isPending, isError } = useQuotaTeamAutocompleteQuery();

	const handleToggle = useCallback(
		(value: string) => {
			const next = selectedQuotaTeams.includes(value)
				? selectedQuotaTeams.filter(item => item !== value)
				: [...selectedQuotaTeams, value];
			onChange?.(next);
		},
		[selectedQuotaTeams, onChange]
	);

	const handleClearAll = useCallback(() => {
		onChange?.([]);
	}, [onChange]);

	const checkedCount = selectedQuotaTeams.length;
	const isEmpty = !isPending && !isError && quotaTeams.length === 0;
	const message = isPending
		? 'Loading quota teams...'
		: isError
			? 'Error loading quota teams'
			: isEmpty
				? 'No quota teams configured'
				: checkedCount === 0
					? 'Select quota teams...'
					: `${checkedCount} quota team${checkedCount === 1 ? '' : 's'} selected`;

	return (
		<Dropdown>
			<DropdownSelectTrigger styles={[bs.wFull]} disabled={isPending || isEmpty}>
				{message}
			</DropdownSelectTrigger>
			<DropdownContent>
				{!isPending &&
					!isError &&
					quotaTeams.map(team => (
						<DropdownCheckboxItem
							key={team}
							checked={selectedQuotaTeams.includes(team)}
							onCheckedChange={() => handleToggle(team)}
						>
							{team}
						</DropdownCheckboxItem>
					))}
				{checkedCount > 0 && (
					<>
						<DropdownSeparator />
						<DropdownItem onClick={handleClearAll}>Clear all</DropdownItem>
					</>
				)}
			</DropdownContent>
		</Dropdown>
	);
};
